import { createStructuredSelector } from "reselect";

export const getAccountId = data => {
  return data.globalState.accountID;
};

export const getInvestmentDashboardStates = data => {
  return data.investmentDashboard;
};

export const getInvestmentDashboardAccDataStates = data => {
  const accData = getInvestmentDashboardStates(data);
  return accData.accountData;
};
export const getInvestmentDashboardRecentDataStates = data => {
  const recentData = getInvestmentDashboardStates(data);
  return recentData.recentTabData;
};
export const getInvestmentDashboardRecurringDataStates = data => {
  const recurringData = getInvestmentDashboardStates(data);
  return recurringData.recurringTabData;
};

export const selectAccData = state => {
  const accountData = getInvestmentDashboardAccDataStates(state);
  return accountData.data;
};
export const selectAccDataLoading = state => {
  const accDataLoading = getInvestmentDashboardAccDataStates(state);
  return accDataLoading.isLoading;
};

export const selectRecentData = state => {
  const recentTabData = getInvestmentDashboardRecentDataStates(state);
  return recentTabData.data;
};
export const selectRecentDataLoading = state => {
  const isLoadingRecent = getInvestmentDashboardRecentDataStates(state);
  return isLoadingRecent.isLoading;
};

export const selectRecurringData = state => {
  const recurringData = getInvestmentDashboardRecurringDataStates(state);
  return recurringData.data;
};
export const selectRecurringDataLoading = state => {
  const isLoadingrecurring = getInvestmentDashboardRecurringDataStates(state);
  return isLoadingrecurring.isLoading;
};

export const investmentDashboardDerivedStates = createStructuredSelector({
  accData: selectAccData,
  isLoadingAccount: selectAccDataLoading,
  recentData: selectRecentData,
  isLoadingRecent: selectRecentDataLoading,
  recurringData: selectRecurringData,
  isLoadingRecurring: selectRecurringDataLoading,
  accountID: getAccountId
});
